import React from "react";
import "./contactUs.css";

export default function ContactUs() {
  return (
    <section id="ContactUs" className="contactUs">
      <div className="contactContent">
        <div className="contactHead">
          <h1>
            Contact Us
            <img src="./images/Logos/Vector.png" alt="Vector"></img>
          </h1>
          <p>
            At BH Smith, we are committed to providing our customers with the
            best solar mounting systems on the market. Our team of experts is
            dedicated to staying at the forefront of the industry, and we are
            constantly researching and developing new technologies to improve
            our products. We believe in the power of solar energy and are
            dedicated to helping our customers make the most of it. Choose BH
            Smith for a smarter, more sustainable energy solution
          </p>
        </div>
        <div className="contactInfo">
          <div className="contactInfoBox">
            <i className="bi bi-telephone-fill"></i>
            <div className="infoContent">
              <h6>+92 321 3888624</h6>
              {window.location.pathname === "/bhRenewable" ? (
                <h6>+92 321 1119260</h6>
              ) : (
                <h6>+92 42 32390262</h6>
              )}
            </div>
          </div>
          <div className="contactInfoBox">
            <i className="bi bi-envelope-fill"></i>
            <div className="infoContent">
              <h6>info@bhgroup.com.pk</h6>
              <h6>support@bhgroup.com.pk</h6>
            </div>
          </div>
          <div className="contactInfoBox">
            <i className="bi bi-geo-alt-fill"></i>
            <div className="infoContent">
              <h6>BH Group, 13-A, G-Block, MA Johar Town, Lahore</h6>
            </div>
          </div>
        </div>
        <div className="copyRights">
          <hr></hr>
          <h6>© Copyright 2023, All Rights Reserved By Babar Hussain Group</h6>
        </div>
      </div>
    </section>
  );
}
